
import { ALL_BOT_TYPE } from './constants';
import { reportTransferType, TransferType } from './reportTransferType';
import coreStore from '@/stores/core';

export const shouldReportLiveAgentForNoAgent = (
  isLiveAgentUnavailable: boolean,
) => {
  const initStore = coreStore.safeGetStore('initStore');
  const agentStore = coreStore.safeGetStore('agentStore');

  if ((initStore?.botType === ALL_BOT_TYPE.INTENT_BASE_BOT
    || initStore?.botType === ALL_BOT_TYPE.SELLER_BASE_BOT) && isLiveAgentUnavailable) {
    reportTransferType({
      sessionId: initStore.sessionId,
      transferType: TransferType.ToLiveAgent,
    });
    agentStore.UPDATE_ONCE_IN_QUEUE();
  }
};
